import React from 'react';
import '../Contact.css';

 function Contact(){
    return <>
    <div className='container'>
    <h3>HOW TO CONTACT US: </h3>
    <br></br>
    <p> Mailing Address: 4th floor, Government Media Center Bldg. (PIA), Vasra, Quezon City, 1128 Metro Manila, Republic of the Philippines </p>
    <br></br>
    <p>Office Hours: Monday to Friday from 0800 to 1700 hours (+800GMT) except Public and Non-working Holidays</p>
    <br></br>
    <p>Contact Numbers: Country Code (63) Area Code (2) 924.26.07 | Night time (+63.2) 453.02.38</p>
    <br></br>
    <p>E-mail: pbsinfo.ph@gmail.com</p>
    <br></br>
    <p>Smartphone App: PBS rAPPS (via Android/Iphone)</p>
    <br></br>
    <p>For GPS Locator: Type the following - Visayas Ave. Quezon City, or Philippine Information Agency building</p>
    <br></br>
    <p>Global Position Address: 14° 39' 19.3212” N |121° 2' 45.7152” E</p>
    <br></br>
    <br></br>
    <h3>HOW TO REACH US:</h3>
    <br></br>
    <p>Driving to PBS National Office:</p>
    <br></br>

    <p>1. From anywhere in Metro Manila, one must proceed to the Government Center surrounding the Quezon Memorial Circle. From the roundabout highway Elliptical Road, turn right to Visayas Avenue and from the left, second building complex is the Government Media Center or (Philippine Information Agency);</p>
    <br></br>

    <p>2. From Tandang Sora Avenue, kindly head South via Visayas Avenue towards the Elliptical Road. After Road 1, after the Department of Environment and Natural Resources compound to your right is the Government Media Center;</p>
    <br></br>

    <p>Commuting to PBS National Office:</p>
    <br></br>

    <p>1. From along Epifanio de los Santos Avenue or EDSA, via the Metro Rail Transit, drop off either the Quezon Ave. Station or GMA Kamuning Station and take a jeep bound (at minimum fare) for Quezon City Hall - National Housing Authority. From there, take the Tandang Sora bound jeep (at minimum fare) and drop off at the Government Media Center.</p>
    <br></br>
    <p>2. Via BUS, from ‘EDSA’ or ‘Quezon Avenue,’ bus lines, take the bus bound for ‘Fairview’ and drop off at the ‘Quezon City Hall – National Housing Authority’ bus stop and take the ‘Tandang Sora’ bound jeep (at minimum fare) and drop off at the ‘Government Media Center.’</p>
    </div>

   </>

}

export default Contact;
